var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rm
    ? _c(
        "div",
        [
          _vm.isConfirmationVisible === true
            ? [
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-center",
                    staticStyle: { "padding-top": "200px" },
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("h5", { staticClass: "card-title" }, [
                          _vm._v("Thank you!"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text lead" }, [
                          _vm._v(
                            "We've got your request. Do you want to add another?"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.reload },
                          },
                          [_vm._v("Add another")]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isConfirmationVisible === false
            ? [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-10 col-md-12 offset-lg-1" },
                      [
                        _c("img", {
                          staticStyle: { "margin-top": "15px" },
                          attrs: { src: _vm.rm.LogoUrl },
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.rm.ContentHtml) },
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm.rm
                          ? _c("AlternativeEditor", {
                              attrs: {
                                propRm: _vm.rm.AlternativeEditor,
                                propErrors: _vm.errors,
                                propFormId: "requestPageAlternativeForm",
                              },
                              on: { "form-submit": _vm.save },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              type: "submit",
                              form: "requestPageAlternativeForm",
                            },
                          },
                          [_vm._v("Confirm")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }